import { Component, ElementRef, Inject, Injector } from '@angular/core';
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { AppComponentBase } from "../../../services/AppComponentBase";
import { IChangePasswordReq, IChangePasswordRs } from '../../../interfaces/service.response';
import * as API from "../../../api/DixApiClient";
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../services/data/data.service';

@Component( {
    selector: "modal-providerConnection",
    template: require('./providerConnection.component.html'),
    styles: [ require('./providerConnection.component.css') ]
} )

export class ProviderConnectionModal extends AppComponentBase {
    providers: any[] = [];
    selectedProvider: string = "OANDA";
    selectedAccount: string = "";

    constructor ( injector: Injector, protected router: Router, public activeModal: NgbActiveModal, http: HttpClient ) {
        super( injector );
        new API.OauthClient( http ).getAccounts().subscribe( ( tp ) => {
            this.providers = tp;
            if ( tp.length > 0 ) {
                this.selectedProvider = tp[ 0 ].providerId as string;
            }
        } );
    }

    redirectToLogin () {
        switch ( this.selectedProvider ) {
            case "OANDA":
                window.location.href = `https://www1.oanda.com/register/#/sign-up`;
                break;
            default:
                break;
        }

    }

}

